import { type CommonAction, success } from "@iflyrpa/share";
import { z } from "zod";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface GetBaijiahaoConfigParams extends ActiomCommonParams {
    token: string;
}

export const ConfigDataSchema = z.object({
    id: z.string(),
    name: z.string(),
    detail: z.string(),
    is_enable: z.number(),
    publish_num_left: z.number().nullable().optional(),
});

export type ConfigData = z.infer<typeof ConfigDataSchema>;

export type PublishAction = CommonAction<GetBaijiahaoConfigParams, ConfigData[]>;

export const getBaijiahaoConfig: PublishAction = async (_task, params) => {
    const cookies = params.cookies ?? [];

    const http = new Http({
        headers: {
            cookie: cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            token: params.token,
        },
    });

    const res = await http.api<{
        data: { article: { activity_list: ConfigData[] }; ability?: { publish_num_left: number } };
    }>({
        method: "get",
        url: "https://baijiahao.baidu.com/pcui/article/edit",
        params: {
            type: "news",
        },
    });
    const data: ConfigData[] =
        res?.data?.article.activity_list.map((_item) => {
            return {
                id: _item.id,
                name: _item.name,
                detail: _item.detail,
                is_enable: _item.is_enable,
            };
        }) ?? [];
    res.data?.ability
        ? data.push({
              id: "bjh_publish_num_left",
              name: "账号剩余发文数",
              detail: "",
              is_enable: 1,
              publish_num_left: res.data.ability.publish_num_left,
          })
        : null;
    return success(data, "获取百家号配置项成功!");
};
